import { createContext, useContext, useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import db from "../firebase/firebaseConfig";
import { SITE_DOMAIN, SITE_EMAIL, SITE_NAME } from "../utils/siteConfig";

const LocalContext = createContext();

export const LocalProvider = ({ children }) => {
  const [currentTFN, setCurrentTFN] = useState({ intlFormat: "", localFormat: "" });
  const [webinfo, setwebinfo] = useState({
    name: SITE_NAME,
    phone: "",
    phonecall: "",
    email: SITE_EMAIL,
    address: "Remote · Worldwide",
  });

  useEffect(() => {
    const fetchTFN = async () => {
      try {
        const docId = process.env.REACT_APP_FIREBASE_SITE_DOC || SITE_DOMAIN;
        const docRef = doc(db, "siteNumbers", docId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setCurrentTFN({
            intlFormat: data.numberIntl || "",
            localFormat: data.numberLocal || "",
          });
        } else {
          setCurrentTFN({ intlFormat: "", localFormat: "" });
        }
      } catch (error) {
        console.error("Error fetching TFN: ", error);
      }
    };

    fetchTFN();
  }, []);

  useEffect(() => {
    const local = String(currentTFN.localFormat || "").trim();
    const intlRaw = String(currentTFN.intlFormat || "").trim();
    const intlTel = intlRaw.replace(/[^\d+]/g, "").replace(/(?!^)\+/g, "");
    const localTel = local.replace(/[^\d+]/g, "").replace(/(?!^)\+/g, "");
    const phonecall = intlTel || localTel;
    const phone = local || intlRaw || phonecall;
    setwebinfo((prev) => ({ ...prev, phone, phonecall }));
  }, [currentTFN]);

  return (
    <LocalContext.Provider value={{ webinfo, setwebinfo }}>
      {children}
    </LocalContext.Provider>
  );
};

export const useLocalContext = () => useContext(LocalContext);
